import { messages as portugueseMessages } from "./pt";
import { messages as englishMessages } from "./en";
import { messages as spanishMessages } from "./es";
import { messages as italianMessages } from "./it";

const messages = {
	...portugueseMessages,
	...englishMessages,
	...spanishMessages,
	...italianMessages,
};

export { messages };
